import { baseApi, baseApiReturn } from "@dex/bubl-fetch";

const endpoint = 'Orders';

const OrdersApi: baseApiReturn = baseApi(endpoint);

export default OrdersApi;